import React from 'react';
import { connect } from 'react-redux';
import { SvgIcon, Grid } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import GeneralIcon from '@mui/icons-material/MusicVideoRounded';
import AudioIcon from '@mui/icons-material/GraphicEqRounded';
import BackgroundIcon from '@mui/icons-material/PanoramaRounded';
import TextIcon from '@mui/icons-material/TextFieldsRounded';
import { mdiSineWave } from '@mdi/js';
import SettingsPanelButton from './SettingsPanelButton';
import CreatePageConstants from '../CreatePageConstants';
import SubjectRoundedIcon from '@mui/icons-material/SubjectRounded';
import { createActions } from '../store';
import CategoryRoundedIcon from '@mui/icons-material/CategoryRounded';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';

const styles = theme => ({
    buttonsContainer: {
        maxHeight: `calc(100vh - calc(${theme.spacing(9)} * 2))`,
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        flexWrap: 'nowrap',
    },
});

const SettingsPanelTabs = ({ classes, currentSettingsPanel, lyricsPanelVisited, featuresPanelVisited, setProperty }) => {
    const lyricsNewBadgeTimeoutAchieved = (new Date()) > (new Date(CreatePageConstants.LYRICS_NEW_BADGE_TIMEOUT));
    const setPanel = (value) => setProperty("currentSettingsPanel", value);

    return (
        <Grid
            container
            direction='column'
            justifyContent='flex-start'
            alignItems='center'
            className={classes.buttonsContainer}
            spacing={2}
            id='setting-panel-buttons-container'
        >
            <Grid>
                <SettingsPanelButton
                    icon={<GeneralIcon />}
                    onClick={() => setPanel(CreatePageConstants.SETTINGS_PANELS.GENERAL)}
                    active={currentSettingsPanel === CreatePageConstants.SETTINGS_PANELS.GENERAL}
                >
                    General
                </SettingsPanelButton>
            </Grid>
            <Grid>
                <SettingsPanelButton
                    icon={<AudioIcon />}
                    onClick={() => setPanel(CreatePageConstants.SETTINGS_PANELS.AUDIO)}
                    active={currentSettingsPanel === CreatePageConstants.SETTINGS_PANELS.AUDIO}
                >
                    Audio
                </SettingsPanelButton>
            </Grid>
            <Grid>
                <SettingsPanelButton
                    icon={<SvgIcon><path d={mdiSineWave} /></SvgIcon>}
                    onClick={() => setPanel(CreatePageConstants.SETTINGS_PANELS.VISUALIZER)}
                    active={currentSettingsPanel === CreatePageConstants.SETTINGS_PANELS.VISUALIZER}
                >
                    Visualizer
                </SettingsPanelButton>
            </Grid>
            <Grid>
                <SettingsPanelButton
                    icon={<BackgroundIcon />}
                    onClick={() => setPanel(CreatePageConstants.SETTINGS_PANELS.BACKDROP)}
                    active={currentSettingsPanel === CreatePageConstants.SETTINGS_PANELS.BACKDROP}
                >
                    Backdrop
                </SettingsPanelButton>
            </Grid>
            <Grid>
                <SettingsPanelButton
                    icon={<TextIcon />}
                    onClick={() => setPanel(CreatePageConstants.SETTINGS_PANELS.TEXT)}
                    active={currentSettingsPanel === CreatePageConstants.SETTINGS_PANELS.TEXT}
                >
                    Text
                </SettingsPanelButton>
            </Grid>
            <Grid>
                <SettingsPanelButton
                    icon={<SubjectRoundedIcon />}
                    onClick={() => setPanel(CreatePageConstants.SETTINGS_PANELS.LYRICS)}
                    active={currentSettingsPanel === CreatePageConstants.SETTINGS_PANELS.LYRICS}
                    badge={(lyricsPanelVisited || lyricsNewBadgeTimeoutAchieved) ? null : 'NEW'}
                >
                    Lyrics
                </SettingsPanelButton>
            </Grid>
            <Grid>
                <SettingsPanelButton
                    icon={<CategoryRoundedIcon />}
                    onClick={() => setPanel(CreatePageConstants.SETTINGS_PANELS.ELEMENTS)}
                    active={currentSettingsPanel === CreatePageConstants.SETTINGS_PANELS.ELEMENTS}
                >
                    Elements
                </SettingsPanelButton>
            </Grid>
            <Grid>
                <SettingsPanelButton
                    id='features-panel-button'
                    icon={<AutoAwesomeRoundedIcon />}
                    onClick={() => setPanel(CreatePageConstants.SETTINGS_PANELS.FEATURES)}
                    active={currentSettingsPanel === CreatePageConstants.SETTINGS_PANELS.FEATURES}
                    badge={featuresPanelVisited ? null : 'NEW'}
                >
                    Features
                </SettingsPanelButton>
            </Grid>
        </Grid>
    );
}

const mapStateToProps = (state) => {
    const { currentSettingsPanel, lyricsPanelVisited, featuresPanelVisited } = state.create;

    return {
        currentSettingsPanel,
        lyricsPanelVisited,
        featuresPanelVisited
    };
};

const mapDispatchToProps = (dispatch) => {
    const setProperty = (key, value) => dispatch(createActions.setProperty(key, value));
    return { setProperty }
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(SettingsPanelTabs, styles));